import {panelConstants} from "../constants/panel.constants";

export function panelReducer(state = {}, action) {
    switch (action.type) {
        case panelConstants.MENU_SUCCESS:
            return {
                menu: action.menu
            };
        case panelConstants.MENU_REQUEST:
            return {};
        case panelConstants.MENU_FAILURE:
            return {};
        default:
            return state
    }
}
